import { render } from "./JoinIn.vue?vue&type=template&id=b6795e06&scoped=true"
import script from "./JoinIn.vue?vue&type=script&lang=js"
export * from "./JoinIn.vue?vue&type=script&lang=js"

import "./JoinIn.vue?vue&type=style&index=0&id=b6795e06&lang=scss&scoped=true"

import exportComponent from "/Users/vee/Desktop/git/web/bitcoooPcWebsite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6795e06"]])

export default __exports__